var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { mobile: _vm.isMobile(_vm.$mq) } },
    [
      _c("div", { staticClass: "paywall-testimonials row paywall-section" }, [
        _c(
          "div",
          { staticClass: "container" },
          [_c("Reviews", { attrs: { "for-full-paywall": true } })],
          1
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.isMobile(_vm.$mq)
        ? _c("PremiumFeatures", { attrs: { forFullPaywall: "" } })
        : _vm._e(),
      _vm._v(" "),
      _c("PaywallFeatures"),
      _vm._v(" "),
      _c("WhatCanILearn")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "paywall-audience row paywall-section-gray" },
      [
        _c("h2", [_vm._v("Who is Brilliant for?")]),
        _vm._v(" "),
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "row icon" }, [
              _c("span", { staticClass: "b-sprite-paywall-pix-satellite" })
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Students")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          Master concepts through problem solving in math, science, and computer science. Build\n          intuition instead of memorizing formulas.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "row icon" }, [
              _c("span", { staticClass: "b-sprite-paywall-pix-brain" })
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Professionals")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          Keep your knowledge base fresh and prepare for quantitative interviews. Explore topics\n          from probability to computer science to machine learning.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "row icon" }, [
              _c("span", { staticClass: "b-sprite-paywall-pix-globe" })
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Lifelong learners")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          Choose from fun, guided exercises in hundreds of interesting topics. Keep your mind\n          active and improve critical thinking skills.\n        "
              )
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }